import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getUserChallenge, addUserToChallenge, removeUserFromChallenge } from './thunks'

const initialState: UserChallengeState = {
  // TODO: Do we need values for the initial state?
  userChallenge: null,
  status: 'idle',
  error: null as string | null,
}

const slice = createSlice({
  name: 'challenge',
  initialState,
  reducers: {
    clearUserChallenge: () => {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserChallenge.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getUserChallenge.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getUserChallenge.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.userChallenge = action.payload.data
      })
      .addCase(addUserToChallenge.rejected, (state, action) => {
        state.error = action?.payload?.message || 'Failed to add user to challenge.'
      })
      .addCase(removeUserFromChallenge.rejected, (state, action) => {
        state.error = action?.payload?.message || 'Failed to remove user from challenge.'
      })
  },
})

// Map id to challengeId for now, since mock data uses id instead of challengeId.
// When done, we can just return state.userChallenge without mapping.
export const selectUserChallenge = (state: RootState): UserChallengeState => state.userChallenge

export default slice.reducer
